export default "__VITE_ASSET__DTO6EOYx__"